/*
 * @Description: 云途-线索管理模块
 * @Author: mdb
 * @Date: 2022-07-16 13:58:35
 * @LastEditTime: 2022-08-25 14:18:06
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import type {
  LbuSalesClueParams,
  LbuSalesClueListResult,
  LbuPublicClueParams,
  LbuPublicClueListResult
} from '@/typings/api/clueManage'

/**
 * ************************************** 销售线索 **************************************
 */
//  获取销售线索列表数据
export function salesClueList(data?: LbuSalesClueParams) {
  return request.post<LbuSalesClueListResult, LbuSalesClueListResult>('/lbu/api/clue/page/list', data)
}
// 删除销售线索
export function salesClueDelete(data: { clueIdList: any[] }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/delete', data)
}
//  分配线索
export function salesClueAllot(data: { clueIdList: any[]; follower: string }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/allot', data)
}
// 新增销售线索
export function salesClueCreate(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/create', data, custom)
}
// 修改销售线索
export function salesClueEdit(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/update', data, custom)
}
// 销售线索详情
export function salesClueDetail(data: { clueId: string }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/detail', data)
}
export function clueMerge(data: { clueId: string }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/merge', data)
}
/**
 * ************************************** 线索公海池 **************************************
 */
//  获取线索公海池列表数据
export function publicClueList(data?: LbuPublicClueParams) {
  return request.post<LbuPublicClueListResult, LbuPublicClueListResult>('/lbu/api/clue/pond/page/list', data)
}
// 领取线索
export function publicClueCollect(data: { clueIdList: any[] }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/collect', data)
}
// 退回线索
export function salesClueRefund(data: { clueIdList: any[] }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/clue/refund', data)
}
